import heic2any from "heic2any";

export default class ImageConvertor {
  static convertImage = async (file) => {
    const blobURL = URL.createObjectURL(file);
    let res = await fetch(blobURL)
      .then((res) => res.blob())
      .then((blob) => heic2any({ blob, toType: "image/jpeg" }))
      .then((conversionResult) => {
        return conversionResult;
      })
      .catch((e) => {});
    return res;
  };
}



// WEBPACK FOOTER //
// ./src/utils/ImageConvertor.js